const Style = {

  onboarding: 'relative w-[95%] max-w-[56rem] mt-10 mx-auto mb-10 overflow-hidden rounded-[28px] bg-white shadow-[0_24px_70px_rgba(15,15,15,0.22)] md:w-[52rem] md:min-h-[31rem]',
  sidebar: `bg-[#FFB800] p-6 pr-24 text-[#0F0F0F] md:absolute md:inset-y-0 md:left-0
  md:z-10 md:w-56 md:pr-6`,
  
  logo: 'm-0 mb-6 h-auto w-36',
  main: 'relative min-h-[31rem] bg-white p-6 pt-16 pb-20 md:p-8 md:pt-7 md:pb-20 md:pl-64',
  header: 'w-full pb-4 mb-5 bg-transparent border-b border-slate-100',
  name: 'text-2xl font-bold tracking-[-0.02em] text-[#0F0F0F]',
  description: 'text-sm leading-5 text-slate-500',
  checklist: 'mt-5 text-sm font-semibold md:absolute md:top-1/2 md:-translate-y-1/2 md:left-6 md:right-6',
  nav: 'absolute bottom-5 left-6 right-6 md:left-64 md:right-8',
  prev: 'float-left text-sm font-semibold text-slate-500',
  next: 'float-right text-sm font-semibold text-[#0F0F0F]',
  skip: 'top-4 right-4 z-20 text-xs font-semibold text-slate-500 hover:text-[#0F0F0F]',
  article: 'relative min-h-[17em]'

}

export default Style;
